import { css, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement("pdf-input-maker")
export class PDFinputMaker extends LitElement {
  @property({ type: String }) placeHolder = 'placeholder';
  @property({ type: String }) buttonText = 'Press me';

  static styles = css`
    button {
      padding: 8px 14px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
    }
  `

  private handleClick() {
    // bubble + composed so frameworks outside shadow DOM can listen
    this.dispatchEvent(new CustomEvent('onClickButton', {
      detail: { ok: true },
      bubbles: true,
      composed: true
    }));
  }

  protected render() {
    return html`
      <div>
        <input placeholder=${this.placeHolder} />
        <br />
        <button @click=${this.handleClick}>${this.buttonText}</button>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pdf-input-maker': PDFinputMaker
  }
}